import React from "react";
import { Typography } from "@material-tailwind/react";

interface NextMaintenanceProps {
  status: 'upcoming' | 'current' | 'none';
  date?: string;
  time?: string;
  remainingTime?: string;
  isGlobal?: boolean;  // Flag to indicate if this is global or service maintenance
  serviceName?: string; // Name of the service for service maintenance
}

const NextMaintenance: React.FC<NextMaintenanceProps> = ({ 
  status, 
  date, 
  time,
  remainingTime,
  isGlobal = true, // Default to global maintenance
  serviceName = ""  // Service name (empty for global)
}) => {
  return (
    <div className="box-border flex flex-row items-center p-2 px-8 bg-indigo-50 border border-indigo-500 rounded-2xl shadow-xl gap-4">
        {status === 'upcoming' && (
            <>
            <div>
                <Typography 
                    className="font-jetbrains-mono font-bold text-2xl text-center text-indigo-600"
                    placeholder={undefined}
                    onResize={undefined}
                    onResizeCapture={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                >
                    {isGlobal ? "Global Maintenance" : `${serviceName} Maintenance`}
                </Typography>
      <Typography 
          className="font-jetbrains-mono font-bold text-base text-indigo-600 text-left"
          placeholder={undefined}
          onResize={undefined}
          onResizeCapture={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          Scheduled for
        </Typography>
        </div>
      <div className="flex flex-col justify-center items-start p-0">
        
        <div className="text-right">
          <Typography 
            className="font-jetbrains-mono font-bold text-base text-indigo-600"
            placeholder={undefined}
            onResize={undefined}
            onResizeCapture={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            {date}
          </Typography>
          <Typography 
            className="font-jetbrains-mono font-bold text-3xl text-indigo-600"
            placeholder={undefined}
            onResize={undefined}
            onResizeCapture={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          >
            {time}
          </Typography>
        </div>
      </div>
      </>
      )}
      {status === 'current' && (
        <>
        <div>
                            <Typography 
                className="font-jetbrains-mono font-normal text-base text-center text-indigo-600"
                placeholder={undefined}
                onResize={undefined}
                onResizeCapture={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
            >
                {isGlobal ? "Global Maintenance" : `${serviceName} Maintenance`}
            </Typography>
            <Typography 
                className="font-jetbrains-mono font-bold text-3xl text-indigo-600 text-center"
                placeholder={undefined}
                onResize={undefined}
                onResizeCapture={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
            >
                {remainingTime}
            </Typography>
        </div>
        </>
      )}
      {status === 'none' && (
        <>
        <div>
            <Typography
                className="font-jetbrains-mono font-bold text-2xl text-indigo-600"
                placeholder={undefined}
                onResize={undefined}
                onResizeCapture={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
            >No Scheduled Maintenance</Typography>
        </div>
        </>
      )}
    </div>
  );
};

export default NextMaintenance; 